/*
 * Party Social — Table Linen Size Finder
 * Logic lives here because Shopify's page editor strips inline <script> tags.
 * Markup, CSS and the theme-asset fabric photos come from sections/linen-calculator.liquid.
 *
 * Sizing rule: floor length = table size + (75 cm drop x 2), rounded up to the
 * nearest stocked cloth. 180 cm round + 150 = 330 -> 335 cm stocked.
 */
(function () {
  function init() {
    var root = document.getElementById('ps-linen-finder');
    if (!root || root.dataset.psReady === 'true') return;
    root.dataset.psReady = 'true';

    // A missing theme asset should leave a clean gap, not a broken-image frame.
    root.querySelectorAll('[data-fabric-image], #lf-result-photo').forEach(function (img) {
      img.addEventListener('error', function () { img.style.visibility = 'hidden'; });
      img.addEventListener('load', function () { img.style.visibility = ''; });
    });

    const state = { step: 1, planning: 'known', shape: 'round', look: 'full', colour: 'flexible', fabric: 'linen' };
    const sizes = {
      round: [
        { value: '90', label: '90 cm round' },
        { value: '120', label: '120 cm round' },
        { value: '150', label: '150 cm round' },
        { value: '180', label: '180 cm / 6 ft round — standard hotel banquet table', selected: true }
      ],
      rect: [
        { value: '183x76', label: '183 × 76 cm / 6 ft table', selected: true },
        { value: '244x76', label: '244 × 76 cm / 8 ft table' }
      ],
      cocktail: [
        { value: '60', label: '60 cm cocktail table' },
        { value: '70', label: '70 cm cocktail table', selected: true },
        { value: '80', label: '80 cm cocktail table' }
      ]
    };
    const fabricImages = JSON.parse(root.dataset.images || '{}');
    const roundStock = [228, 274, 305, 335];
    const rectStock = [
      { l: 274, w: 137 },
      { l: 274, w: 178 },
      { l: 335, w: 230 },
      { l: 360, w: 280 },
      { l: 390, w: 270 }
    ];
    const prices = { linen: 'AED 70 each', satin: 'AED 70–80 each', velvet: 'AED 70 each', pattern: 'AED 100–120 each' };
    const fabricColours = {
      round: {
        flexible: ['linen','satin','velvet','pattern'], neutral: ['linen','satin','velvet','pattern'],
        pink: ['linen','satin','velvet','pattern'], blue: ['linen','satin','velvet','pattern'],
        green: ['linen','satin','velvet','pattern'], gold: ['linen','satin','velvet','pattern'],
        dark: ['linen','satin','pattern'], warm: ['linen','satin','velvet','pattern']
      },
      rect: {
        flexible: ['linen','satin','velvet','pattern'], neutral: ['linen','satin','velvet','pattern'],
        pink: ['linen','satin','velvet','pattern'], blue: ['linen','satin','velvet','pattern'],
        green: ['linen','satin','pattern'], gold: ['linen','satin','velvet','pattern'],
        dark: ['linen','satin','pattern'], warm: ['linen','satin','pattern']
      }
    };
    const colourNames = {
      flexible: 'Flexible colour', neutral: 'White or cream', pink: 'Pink or blush', blue: 'Blue or turquoise',
      green: 'Green', gold: 'Gold or sand', dark: 'Black or grey', warm: 'Red or orange'
    };
    const colourExamples = {
      flexible: 'Showing every fabric family.', neutral: 'Examples include White, Cream, Off White and Butter Cream.',
      pink: 'Examples include Blush Pink, Light Pink, Old Rose and Fuchsia.',
      blue: 'Examples include Navy, Peacock, Dusty Blue, Steel Blue and Turquoise.',
      green: 'Examples include Olive Green, Royal Green, Mint and Sage.',
      gold: 'Examples include Champagne Gold, Gold, Sand and Taupe.',
      dark: 'Examples include Black, Dark Grey, Grey and Light Grey.',
      warm: 'Examples include Red, Coral, Peach, Auburn and Burnt Orange.'
    };

    function filterFabrics() {
      const shapeMap = fabricColours[state.shape] || fabricColours.round;
      const allowed = shapeMap[state.colour];
      const cards = [...root.querySelectorAll('[data-group="fabric"] button')];
      cards.forEach((card) => { card.hidden = !allowed.includes(card.dataset.value); });
      if (!allowed.includes(state.fabric)) {
        state.fabric = allowed[0];
        cards.forEach((card) => card.setAttribute('aria-pressed', String(card.dataset.value === state.fabric)));
      }
      root.querySelector('#lf-fabric-heading').textContent = state.colour === 'flexible' ? 'Explore all fabric styles' : 'Available in this colour family';
      const shapeText = state.shape === 'rect' ? 'rectangular' : state.shape === 'round' ? 'round' : 'selected';
      root.querySelector('#lf-colour-note').textContent = `${colourExamples[state.colour]} Showing website-listed options for ${shapeText} tables; final shade, quantity and date availability will be confirmed.`;
    }

    function updatePlanningFields() {
      const usingGuests = state.planning === 'guests';
      root.querySelector('#lf-guest-fields').hidden = !usingGuests;
      root.querySelector('#lf-quantity-label').textContent = usingGuests ? 'Planning quantity' : 'Number of tables';
      updateQuantityEstimate();
    }

    function selectedCapacity() {
      if (state.shape === 'round') return { '90': 4, '120': 6, '150': 8, '180': 8 }[root.querySelector('#lf-table-size').value] || 8;
      if (state.shape === 'rect') return { '183x76': 6, '244x76': 8 }[root.querySelector('#lf-table-size').value] || 6;
      return null;
    }

    function updateQuantityEstimate() {
      const note = root.querySelector('#lf-estimate-note');
      if (state.planning !== 'guests') {
        note.hidden = true;
        return;
      }
      const guests = Math.max(1, Math.min(5000, Number(root.querySelector('#lf-guests').value) || 1));
      const capacity = selectedCapacity();
      if (!capacity) {
        note.hidden = false;
        note.textContent = 'Guest count saved. Cocktail, serpentine and custom layouts need a table-quantity review, so you can adjust the planning quantity below.';
        return;
      }
      const quantity = Math.ceil(guests / capacity);
      root.querySelector('#lf-quantity').value = quantity;
      note.hidden = false;
      note.textContent = state.shape === 'round' && root.querySelector('#lf-table-size').value === '180'
        ? `${quantity} tables is a comfortable planning estimate for ${guests} guests at 8 per table. A 6 ft hotel banquet table may seat 8–10 depending on the venue layout.`
        : `${quantity} tables is a planning estimate for ${guests} guests using approximately ${capacity} seats per selected table. Please confirm the final venue layout.`;
    }

    function updateSizeOptions() {
      const select = root.querySelector('#lf-table-size');
      select.innerHTML = '';
      const isSpecial = state.shape === 'custom' || state.shape === 'serpentine';
      root.querySelector('#lf-standard-fields').hidden = isSpecial;
      root.querySelector('#lf-custom-fields').hidden = !isSpecial;
      root.querySelector('#lf-personalise-field').hidden = state.shape !== 'custom';
      root.querySelector('#lf-filter-note').textContent = isSpecial ? 'Custom fit and layout review' : `Showing ${state.shape === 'rect' ? 'rectangular' : state.shape} tablecloth sizes`;
      root.querySelector('#lf-size-heading').textContent = state.shape === 'serpentine' ? 'Tell us about the serpentine layout' : isSpecial ? 'Tell us about the custom size' : `Choose your ${state.shape === 'rect' ? 'rectangular' : state.shape} table size`;
      root.querySelector('#lf-size-intro').textContent = state.shape === 'serpentine'
        ? 'Enter the overall layout dimensions or the venue’s section measurements so we can plan a custom-fit or draped treatment.'
        : isSpecial
          ? 'Add the exact dimensions supplied by your venue or planner. Party Social can manufacture special sizes and personalised linens.'
          : state.shape === 'round'
            ? 'Not sure? Most hotel banquet tables are the standard 180 cm / 6 ft round.'
            : 'Select the closest standard size. The result will stay matched to this table shape.';
      if (state.shape === 'serpentine') root.querySelector('#lf-custom-shape').value = 'S-shape / serpentine';
      if (isSpecial) {
        updateQuantityEstimate();
        filterFabrics();
        return;
      }
      sizes[state.shape].forEach((size) => {
        const option = document.createElement('option');
        option.value = size.value;
        option.textContent = size.label;
        option.selected = Boolean(size.selected);
        select.appendChild(option);
      });
      updateQuantityEstimate();
      filterFabrics();
    }

    function select(group, value) {
      state[group] = value;
      root.querySelectorAll(`[data-group="${group}"] button`).forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.value === value)));
      if (group === 'shape') updateSizeOptions();
      if (group === 'colour') filterFabrics();
      if (group === 'planning') updatePlanningFields();
    }

    function renderStep() {
      root.querySelectorAll('.lf-step').forEach((panel) => { panel.hidden = Number(panel.dataset.step) !== state.step; });
      root.querySelector('#lf-step-label').textContent = `Step ${state.step} of 5`;
      root.querySelector('#lf-progress-fill').style.width = `${state.step * 20}%`;
      if (state.step === 5) renderResult();
    }

    function closestRound(required) {
      return roundStock.find((size) => size >= required) || roundStock[roundStock.length - 1];
    }

    function closestRect(requiredL, requiredW) {
      return rectStock.find((size) => size.l + 10 >= requiredL && size.w + 10 >= requiredW) || rectStock[rectStock.length - 1];
    }

    function renderResult() {
      const isSpecial = state.shape === 'custom' || state.shape === 'serpentine';
      const value = isSpecial ? '' : root.querySelector('#lf-table-size').value;
      const label = isSpecial
        ? `${root.querySelector('#lf-custom-shape').value} — ${root.querySelector('#lf-custom-size').value || 'dimensions to confirm'}`
        : root.querySelector('#lf-table-size').selectedOptions[0].textContent;
      const quantity = Math.max(1, Math.min(2000, Number(root.querySelector('#lf-quantity').value) || 1));
      const fabric = state.fabric;
      const isFull = state.look === 'full';
      const drop = 75;
      let result;
      let title;
      let copy;

      if (state.shape === 'serpentine') {
        result = 'Custom to your section layout';
        title = state.look === 'draped' ? 'Serpentine draped linen treatment' : 'Serpentine / S-shaped linen';
        copy = 'A curved layout needs a measurement review so joins, gathers and the finished drape sit cleanly across every section.';
      } else if (state.shape === 'custom') {
        const personalisation = root.querySelector('#lf-personalise').selectedOptions[0].textContent;
        result = root.querySelector('#lf-custom-size').value || 'Made to your measurements';
        title = `Custom-made ${root.querySelector('#lf-custom-shape').value.toLowerCase()} linen`;
        copy = `${personalisation}. Our team will confirm fabric suitability, finished measurements and production timing.`;
      } else if (!isFull) {
        const lookNames = { topper: 'Table topper', runner: 'Table runner', draped: 'Draped linen treatment' };
        result = state.look === 'draped' ? 'Custom to table and styling' : 'Sized to selected table';
        title = lookNames[state.look];
        copy = state.look === 'draped' ? 'Our team will confirm the fabric quantity, gathering and installation details for your chosen look.' : `A ${state.look} is sized separately from our standard floor-length tablecloths.`;
      } else if (state.shape === 'round') {
        const required = Number(value) + (drop * 2);
        const stock = closestRound(required);
        result = `${stock} cm diameter`;
        title = `${stock} cm round tablecloth`;
        copy = `${colourNames[state.colour]} in ${fabric === 'linen' ? 'linen look' : fabric}. The closest stocked size for Party Social’s standard floor-length finish.`;
      } else if (state.shape === 'rect') {
        const [length, width] = value.split('x').map(Number);
        const stock = closestRect(length + drop * 2, width + drop * 2);
        result = `${stock.l} × ${stock.w} cm`;
        title = `${stock.l} × ${stock.w} cm tablecloth`;
        copy = `${colourNames[state.colour]} in ${fabric === 'linen' ? 'linen look' : fabric}. The closest standard Party Social size for a floor-length rectangular setting.`;
      } else {
        const stock = 305;
        result = `${stock} cm round or fitted cover`;
        title = 'Cocktail table cover';
        copy = 'Cocktail-table fit varies by height and base; our team will confirm the best drape or fitted cover.';
      }

      root.querySelector('#lf-result-title').textContent = title;
      root.querySelector('#lf-result-copy').textContent = copy;
      root.querySelector('#lf-result-table').textContent = label;
      root.querySelector('#lf-result-linen').textContent = result;
      root.querySelector('#lf-result-quantity').textContent = `${quantity} ${quantity === 1 ? 'table' : 'tables'}`;
      root.querySelector('#lf-result-price').textContent = isSpecial || !isFull ? 'Custom quote' : prices[fabric];
      root.querySelector('#lf-result-photo').src = fabricImages[fabric] || '';
      root.querySelector('#lf-quote').textContent = isSpecial || !isFull ? 'Request a linen quote' : 'Check colours & availability';
      root.querySelector('#lf-result-note').textContent = state.shape === 'custom'
        ? 'Custom-sized or personalised linens are made-to-order purchases rather than rentals.'
        : state.shape === 'serpentine' || state.look === 'draped'
          ? 'The team will confirm measurements, styling and installation details.'
          : 'Floor length is our standard; final fit depends on the exact venue table.';
    }

    root.querySelectorAll('[data-group] button').forEach((button) => button.addEventListener('click', () => select(button.closest('[data-group]').dataset.group, button.dataset.value)));
    root.querySelectorAll('[data-next]').forEach((button) => button.addEventListener('click', () => { state.step = Math.min(5, state.step + 1); renderStep(); }));
    root.querySelectorAll('[data-back]').forEach((button) => button.addEventListener('click', () => { state.step = Math.max(1, state.step - 1); renderStep(); }));
    root.querySelectorAll('[data-start]').forEach((button) => button.addEventListener('click', () => { state.step = 1; renderStep(); }));
    root.querySelector('#lf-guests').addEventListener('input', updateQuantityEstimate);
    root.querySelector('#lf-table-size').addEventListener('change', updateQuantityEstimate);
    root.querySelector('#lf-quote').addEventListener('click', () => {
      window.location.href = root.dataset.quoteUrl || '/pages/event-rentals-party-social';
    });
    root.querySelectorAll('[data-fabric-image]').forEach((img) => { img.src = fabricImages[img.dataset.fabricImage] || ''; });
    updateSizeOptions();
    updatePlanningFields();
    filterFabrics();
    renderStep();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function () {
    var root = document.getElementById('ps-linen-finder');
    if (root) root.dataset.psReady = '';
    init();
  });
})();
